<template>
	<div class="step-progress">
		<div class="steps">
			<div class="steps-item steps-info">
				<div class="steps-content steps-btn">
					<input type="range" class="steps-slider" ref="stepSlider" :value="value" :min="min" :max="max" :step="step" @input="rangeEvent($event)"
					:style="{'background-size': sliderValueRate + '%, 100%'}">
					<div class="slider-inner-text"><span>{{value}}</span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */

export default {
    data() {
				return {
					
				}
		},
		props: {
			min: Number,
			max: Number,
			step: Number,
			value: Number,
			flag: String,
			value: Number,
		},
		model: {
			event: 'sliderEvent'
		},
		mounted() {
				let step_node = this.$refs.stepSlider;
				$(step_node).val(this.value);
		},
		watch: {
			value: function (newVal) {
				this.$emit('sliderEvent', newVal)
				this.$emit('input', Number(newVal));
			},
		},
		computed: {
			sliderValueRate: function () {
				return Math.round(Number(this.value)/(this.max + this.min)*100)
			},
		},
		methods: {
				// 滑动条 滑动事件
				rangeEvent(e) {
					this.$emit('sliderEvent', Number(e.target.value))
				}
		}
}
</script>

<style lang="scss" scoped>
	.step-progress {
		width: 100%;
		.steps::-webkit-kit-scrollbar {// 隐藏滚动条 57ce91
			display: none;
		}
		.steps:after, ol li:after {
			content: '';
			display: block;
			clear: both;
		}
		.steps {
			height: 40px;
			display: flex;
			color: #fff;
			overflow-x: auto;
			list-style: none;
			.steps-item {
				min-width: 150px;
				width: 95%;
				display: flex;
				align-items: center;
				justify-content: center;
				.steps-content {
					// position: absolute;
					// left: 0px;
					display: flex;
					justify-content: center;
					align-items: center;
					.steps-slider {
						width: 100%;
					}
				}
				.steps-btn:hover {
					cursor: pointer;
				}

				.steps-btn {
					.slider-inner-text {
						// position: absolute;
						width: 30px;
						height: 30px;
						line-height: 30px;
						background-color: #cccccc;
						border-radius: 50%;
						color: #757171;
						font-weight: 700;
						font-size: 13px;
					}
				}	
			}
			.steps-start, .steps-end {
				min-width: 16px;
				.steps-content {
					position: absolute;
					top: 10px;
					left: 0px;
					text-align: center;
					.steps-num {
						height: 10px;
						width: 10px;
						font-size: 12px;
					}
				}
			}
			.steps-end {
				width: 25px !important;
				flex: inherit;
				.steps-content {
					text-align: left;
				}
			}
		}
		
		.steps .steps-end .steps-line {
			display: none;
		}

		/** 滑动条样式 */
		input[type='range'] {
			-webkit-appearance: none;
			height: 8px;
			background-color: gray;
			padding: 0;
			border: none;
			outline: none;
			border-radius: 3px;
		}

		input[type='range']::-webkit-slider-thumb {
			-webkit-appearance: none;
			height: 20px;
			width: 20px;
			border-radius: 15px;
			background-color: #a9a6a6;
			border: 3px solid #57ce91;
			cursor: pointer;
			box-shadow: 0 0 5px #000;
			position: relative;
		}

		input[type='range']::-webkit-slider-thumb:active {
			transform: scale(1.3);
		}

		input[type='range'] {
			background: -webkit-linear-gradient(#45ad82, #45ad82) no-repeat #cccccc;
			background-size: 0 100%;
		}
	}
</style>
